<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <data-table
          ref="dataTable"
          :filters="filters"
          :limit="10"
          url="/forwarding"
          fields="email,status,name"
          content="forwardingList"
          searchFields="name,email,forwarding"
          @editRow="editItem"
          @deleteRow="deleteEvent"
          @toggleStatus="toggleStatus">
          <template slot="title">
            <v-layout row wrap align-center>
              <v-flex lg9>
                <v-text-field
                  v-model="filters.search"
                  label="Buscar..."
                  color="black"
                  solo>
                </v-text-field>
              </v-flex>
              <v-flex md3 class="text-xs-right">
                <v-btn class="k-orange-linear white--text" large @click="show = !show">Agregar emails</v-btn>
              </v-flex>
            </v-layout>
          </template>
        </data-table>
      </v-flex>
    </v-layout>
    <dialog-v2 title="Agregar email" :show="show" @save="save" @close="closeModal">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              name="name"
              label="Nombre"
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-as="Nombre"
              :error-messages="errors.collect('name')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              name="email"
              label="Email"
              v-model="form.email"
              v-validate="'required|max:100|email'"
              data-vv-name="email"
              data-vv-as="Nombre"
              :error-messages="errors.collect('email')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch
              :label="form.status ? 'Desactivar' : 'Activar'"
              v-model="form.status"
              :false-value="0"
              :true-value="1"
              v-validate="'required'"
              data-vv-name="status"
              data-vv-as="Estado"
              :error-messages="errors.collect('status')"></v-switch>
          </v-flex>
        </v-layout>
      </template>
    </dialog-v2>
    <dialog-v2 title="Eliminar email" save-button-text="Eliminar" :show="showDelete" @save="deleteItem" @close="closeDeleteModal">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <span class="headline">
              ¡Advertencia!
            </span>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <span>
              ¿Estas seguro que deseas eliminar el email?
            </span> 
          </v-flex>
        </v-layout>
      </template>
    </dialog-v2>
    <v-snackbar
      color="success"
      :timeout="6000"
      :top="true"
      :right="true"
      v-model="snackbar.model">
      {{ snackbar.msg }}
      <v-btn flat color="light" @click.native="snackbar.model = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue';
import DialogV2 from '@/components/global/DialogV2';
import dataTable from '@/components/global/DataTable';
import dataTableListMixin from '@/mixins/dataTableList';
import forwardingList from '@/components/chat_center_v2/config/ForwardingList';

Vue.component('forwardingList', forwardingList);

const form = {
  email: '',
  name: '',
  status: false,
};

export default {
  inject: ['$validator'],
  mixins: [
    dataTableListMixin,
  ],
  components: {
    DialogV2,
    'data-table': dataTable,
  },
  data() {
    return {
      to: false,
      from: false,
      show: false,
      filters: {
        search: '',
        status: '',
      },
      snackbar: {
        color: '',
        msg: '',
        show: false,
      },
      selected: {},
      deleteId: -1,
      showDelete: false,
      form: {
        ...form,
      },
      statuses: [
        {
          value: '',
          name: 'Estados',
        },
        {
          value: 'activo',
          name: 'Activos',
        },
        {
          value: 'inactivo',
          name: 'Inactivos',
        },
      ],
    };
  },
  computed: {
    url() {
      if (Object.keys(this.selected).length > 0) {
        return `forwarding/${this.selected.id}`;
      }
      return 'forwarding';
    },
    deleteUrl() {
      if (this.deleteId) {
        return `forwarding/${this.deleteId}`;
      }
      return '';
    },
  },
  methods: {
    preventChar(event) {
      if (event.key === '@') {
        event.preventDefault();
      }
    },
    toggleStatus($event) {
      this.selected = $event;
      this.form = this.selected;
      this.save();
    },
    editItem($event) {
      this.selected = $event;
      this.form = this.selected;
      this.show = true;
    },
    deleteEvent($event) {
      this.deleteId = $event.id;
      this.showDelete = true;
    },
    deleteItem() {
      this.axios.delete(`forwarding/${this.deleteId}`).then(() => {
        this.$refs.dataTable.search();
        this.closeDeleteModal();
      });
    },
    save() {
      this.axios({
        url: this.url,
        method: Object.keys(this.selected).length > 0 ? 'PUT' : 'POST',
        data: {
          ...this.form,
        },
      }).then(() => {
        this.$refs.dataTable.search();
        this.closeModal();
      });
    },
    closeDeleteModal() {
      this.showDelete = false;
      this.deleteId = -1;
    },
    closeModal() {
      this.show = false;
      this.selected = {};
      this.form = {
        ...form,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/Forwardings.vue